"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaseEvent = void 0;
const abstract_sales_event_1 = require("./abstract-sales.event");
class PurchaseEvent extends abstract_sales_event_1.AbstractSalesEvent {
    constructor(config) {
        super(config);
        this.config = config;
        this.name = 'purchase';
    }
    getData() {
        var _a, _b;
        return {
            currency: this.config.currency,
            transactionId: this.config.transactionId,
            value: (this.config.value - ((_a = this.config.shipping) !== null && _a !== void 0 ? _a : 0)),
            affiliation: this.config.affiliation,
            coupon: this.config.coupon,
            shipping: this.config.shipping,
            tax: this.config.tax,
            items: Array.isArray(this.config.items) ? this.config.items.map(item => (Object.assign({}, item))) : [],
            discount: this.config.discount,
            customer: (_b = this.config.customer) !== null && _b !== void 0 ? _b : undefined
        };
    }
}
exports.PurchaseEvent = PurchaseEvent;
//# sourceMappingURL=purchase.event.js.map